// app.service.jsx - COMPLETE WORKING CODE

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout } from "./app.slice";
import { toast } from "react-toastify";

const getToken = () => {
  return localStorage.getItem("token");
};

const languageType = {
  en: "English",
  ch: "Chinese",
  tu: "Turkish",
  it: "Italian",
  po: "Polish",
  jp: "Japanese",
  hi: "Hindi",
  ar: "Arabic",
};

const customFetchBaseQuery = async (args, api, extraOptions) => {
  const lng = localStorage.getItem("lng") || "en";

  // Ensure args is always an object
  let modifiedArgs = typeof args === "string" ? { url: args } : { ...args };

  if (!modifiedArgs.params) modifiedArgs.params = {};
  modifiedArgs.params.lng = languageType[lng];

  const baseResponse = await fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  })(modifiedArgs, api, extraOptions);

  if (baseResponse.error) {
    const status = baseResponse.error.status;

    if (status === 401) {
      localStorage.removeItem("token");
      api.dispatch(logout());
      toast.error("Session expired. Please login again.");
      window.location.href = "/login";
    }

    if (baseResponse.error.data?.message) {
      let message = baseResponse.error.data.message;
      if (
        baseResponse.error.data.errors &&
        baseResponse.error.data.errors.length > 0
      ) {
        message += `\n${baseResponse.error.data.errors[0]?.message}`;
      }
      toast.error(message);
    }
  }

  return baseResponse;
};

export const apiService = createApi({
  reducerPath: "api",
  baseQuery: customFetchBaseQuery,
  endpoints: () => ({}),
});

export default apiService;